import { memo } from "react";
import { base } from "../../../constant";
import { useElement, useLocale, useService } from "../../../hooks";
import { useTopNavbarBanner } from "./hooks";

interface TopNavbarBannerProps {
  onClick?: () => void;
}

export const TopNavbarBanner = memo(({ onClick }: TopNavbarBannerProps) => {
  const { t } = useLocale();
  const { isUserLoggedIn, getLoggedInUserData } = useService("User");
  const Button = useElement("Button");
  const { ctaClick } = useTopNavbarBanner({ onClick });
  return (
    <div className="top-nav-bar-banner">
      <div
        className="main-box jumbo-container"
        style={{ backgroundImage: `url("${base.imageBaseUrl}car-icon.png")` }}
      >
        <div className="text-banner">
          <h1>15% Off</h1>
          <div className="right-content">
            <label>Car Detailing Services</label>
            <p>Give Your Car The Best Care it Deserves</p>
          </div>
        </div>
        {(!isUserLoggedIn() ||
          !["manager", "company", "branch", "representative"].includes(
            getLoggedInUserData().role
          )) && (
          <div className="shop-now-btn">
            <Button onClick={ctaClick} className="btn btn-primary">
              {t("bookNow")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
});
